<template>
  <div class="alert alert-info text-break" role="alert">
    {{ message }}
  </div>
</template>
<script>
export default {
  name: 'InfoAlert',
  props: {
    message: {
      type: String,
      required: true,
    }
  }
}
</script>
